// Copyright ©️ 2025 eVolve MEP, LLC

import type { LabelTypeId } from '@evolvemep/api-ts';

import { WORK_ORDER_LABEL_TYPE_ID } from 'components/Mantine/Labels/constants';
import type { LabelsContextType } from 'hooks/typeCacheHooks/useLabels/useLabelsContextValue';
import { useWorkOrderLabels } from 'hooks/typeCacheHooks/useLabels/useWorkOrderLabels';

const mapLabelTypeIdToContext: Record<LabelTypeId, () => LabelsContextType> = {
  [WORK_ORDER_LABEL_TYPE_ID]: useWorkOrderLabels,
};

export const useLabels = (labelTypeId: LabelTypeId) => {
  const useLabelsContext = mapLabelTypeIdToContext[labelTypeId];

  if (!useLabelsContext) {
    throw new Error(`No hook found for label type ID: ${labelTypeId}`);
  }

  return useLabelsContext();
};
